/**
 * Cycles the lines of blocks/rotating-text.liquid. The transitions live in
 * component-rotating-text.css; this only moves the is-active / is-leaving classes.
 */
class RotatingText extends HTMLElement {
  connectedCallback() {
    this.lines = [...this.querySelectorAll('.rotating-text__line')];
    if (!this.lines.length) return;

    // No line is active in the markup, so every exit path has to show one.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.lines[0].style.transition = 'none';
      this.lines[0].classList.add('is-active');
      return;
    }

    this.index = 0;
    this.interval = (parseFloat(this.dataset.interval) || 3) * 1000;
    const delay = (parseFloat(this.dataset.delay) || 0) * 1000;
    this.timer = setTimeout(() => this.#show(this.lines[0]), delay);
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
  }

  #show(line) {
    // Snap the line back below the track without animating, so it slides up
    // even when it last left in place.
    line.classList.remove('is-leaving');
    line.style.transition = 'none';
    void line.offsetHeight;
    line.style.transition = '';
    line.classList.add('is-active');

    if (this.lines.length > 1) {
      this.timer = setTimeout(() => this.#advance(), this.interval);
    }
  }

  #advance() {
    const current = this.lines[this.index];
    this.index = (this.index + 1) % this.lines.length;

    current.classList.remove('is-active');
    current.classList.add('is-leaving');
    this.#show(this.lines[this.index]);
  }
}

if (!customElements.get('rotating-text')) {
  customElements.define('rotating-text', RotatingText);
}
